import { DispositionJobDetailResponse, RequirementResponseItem } from '@/types/service-response'
import i18n from '@/i18n'
import { PersonalDispositionRequirement, WorkFormData } from '@/types'
import { DispositionJobEmployee } from '@/model/disposition/DispositionJobEmployee'
import { DispositionJobStatus } from '@/model/disposition/DispositionJobStatus'

export class DispositionJobDetail {
  public constructor (
    readonly id: number,
    readonly address: number | null,
    readonly addressName: string,
    readonly workRhythm: number | undefined,
    readonly workFormData: WorkFormData[],
    readonly referenceDate: string | null,
    readonly basicHours: string | undefined,
    readonly additionalHours: string | undefined,
    readonly totalHours: string,
    readonly employeeInDistance: string,
    readonly requirements: PersonalDispositionRequirement[],
    readonly dispositionJobEmployeeList: DispositionJobEmployee[],
    readonly statusList: DispositionJobStatus[]
  ) {}

  static createFromResponse (responseData: DispositionJobDetailResponse): DispositionJobDetail | undefined {
    if (responseData) {
      const workFormData: WorkFormData[] = [
        {dayNumber: 1, dayLabel: i18n.t('planningPage.monday').toString(), morning: !!responseData.MontagVM, afternoon: !!responseData.MontagNM, priority: responseData.MontagPrio ? responseData.MontagPrio.toString() : ''},
        {dayNumber: 2, dayLabel: i18n.t('planningPage.tuesday').toString(), morning: !!responseData.DienstagVM, afternoon: !!responseData.DienstagNM, priority: responseData.DienstagPrio ? responseData.DienstagPrio.toString() : ''},
        {dayNumber: 3, dayLabel: i18n.t('planningPage.wednesday').toString(), morning: !!responseData.MittwochVM, afternoon: !!responseData.MittwochNM, priority: responseData.MittwochPrio ? responseData.MittwochPrio.toString() : ''},
        {dayNumber: 4, dayLabel: i18n.t('planningPage.thursday').toString(), morning: !!responseData.DonnerstagVM, afternoon: !!responseData.DonnerstagNM, priority: responseData.DonnerstagPrio ? responseData.DonnerstagPrio.toString() : ''},
        {dayNumber: 5, dayLabel: i18n.t('planningPage.friday').toString(), morning: !!responseData.FreitagVM, afternoon: !!responseData.FreitagNM, priority: responseData.FreitagPrio ? responseData.FreitagPrio.toString() : ''},
        {dayNumber: 6, dayLabel: i18n.t('planningPage.saturday').toString(), morning: !!responseData.SamstagVM, afternoon: !!responseData.SamstagNM, priority: responseData.SamstagPrio ? responseData.SamstagPrio.toString() : ''},
        {dayNumber: 7, dayLabel: i18n.t('planningPage.sunday').toString(), morning: !!responseData.SonntagVM, afternoon: !!responseData.SonntagNM, priority: responseData.SonntagPrio ? responseData.SonntagPrio.toString() : ''}
      ]
      const requirements: PersonalDispositionRequirement[] = responseData.Vorgaben.map((item: RequirementResponseItem) => {
        return {competence: item.Kompetenz}
      })

      const statusList: DispositionJobStatus[] = DispositionJobStatus.createFromResponse(responseData.StatusDetails)

      return new DispositionJobDetail(
        responseData.ID,
        responseData.Adresse,
        responseData.AdressLinie,
        responseData.Wiederholung ? parseInt(responseData.Wiederholung) : undefined,
        workFormData,
        responseData.ReferenzTermin,
        responseData.BasisStd || responseData.BasisStd === 0  ? parseFloat(responseData.BasisStd.toString()).toFixed(2).toString() : undefined,
        responseData.ZusatzStd || responseData.ZusatzStd === 0 ? parseFloat(responseData.ZusatzStd.toString()).toFixed(2).toString() : undefined,
        responseData.TotalStd ? parseFloat(responseData.TotalStd.toString()).toFixed(2).toString() : '',
        responseData.UmkreisVon ? responseData.UmkreisVon.toString() : '0',
        requirements,
        DispositionJobEmployee.createFromResponse(responseData.LaufDetails),
        statusList
        )
    } else {
      return undefined
    }
  }
}